// We support browsers with >0.2% global usage share (see browserslist in package.json).
// As of April 2026, this includes Chrome 109 and iOS Safari 15.6–15.8, which lack
// ES2023 array mutation methods. Polyfill them here rather than pulling in the full
// @vitejs/plugin-legacy + core-js pipeline for just two missing APIs.

if (!Array.prototype.toSorted) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.toSorted = function <T>(compareFn?: (a: T, b: T) => number): T[] {
    return (this as T[]).slice().sort(compareFn);
  };
}

if (!Array.prototype.toReversed) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.toReversed = function <T>(): T[] {
    return (this as T[]).slice().reverse();
  };
}

export {};
